import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import { Plus } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
const InsuranceDetails = ({ onChange }) => {
  const [base_url] = useState(base_url_from_axios_config);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  const [companyListFromAPI, setCompanyListFromAPI] = useState(null);
  const [insurTypeListFromAPI, setInsurTypeListFromAPI] = useState(null);

  const [formdata, setFormData] = useState({});

  useEffect(() => {
    getCompanyList();
    getInsurTypeList();
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.item) {
      // console.log("formdata in insurance edit :", location.state?.item.REG_NO);
      const registrationNumber = location.state?.item.REG_NO;
      fetchFleetInfo(registrationNumber);
      // setIsEditData(location.state.item);
      // setFormData(location.state.item)
      // setIsEdit(true);
    }
  }, [location.state]);

  const fetchFleetInfo = async (regNo) => {
    try {
      const apiURL = `${base_url}/api/CpaysCount/${companyCode}/VEHICLEINFO/${regNo}/-`;
      const response = await axios.get(apiURL);
      const data = response.data[0];
      setFormData(data);

      if (onChange) {
        onChange(data);
      }
    } catch (error) {
      console.error("Error whilefetchFleetInfo!:", error);
    }
  };

  const initialCompanyInAction = {
    company_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  const initialCompanyInActionEdit = {
    company_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  const [showCompanyCreationEditPopup, setShowCompanyCreationEditPopup] =
    useState(false);
  const [companyNameInInputBoxNew, setCompanyNameInInputBoxNew] = useState(
    initialCompanyInAction,
  );
  const [companyNameInInputBoxEdit, setCompanyNameInInputBoxEdit] = useState(
    initialCompanyInActionEdit,
  );

  const editCompanyAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/COMPANY/${companyNameInInputBoxEdit.company_name}/${companyNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getCompanyList();
        setCompanyNameInInputBoxEdit(initialCompanyInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteCompanyAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/COMPANY/${companyNameInInputBoxEdit.company_name}/${companyNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getCompanyList();
        setCompanyNameInInputBoxEdit(initialCompanyInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const newCompanyAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/COMPANY/${companyNameInInputBoxNew.company_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getCompanyList();
        setCompanyNameInInputBoxNew(initialCompanyInAction);
      }, {})
      .catch((err) => {});
  };

  const getCompanyList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/COMPANY/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setCompanyListFromAPI(newArray);
    } else {
      console.error("error");
    }
  };

  // Insurance Type

  const getInsurTypeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/INSURTYPE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setInsurTypeListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (onChange) {
      onChange({ ...formdata, [name]: value });
    }
  };

  const initialInsurTypeInAction = {
    insurType_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  const initialInsurTypeInActionEdit = {
    insurType_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  const [showInsurTypeCreationEditPopup, setShowInsurTypeCreationEditPopup] =
    useState(false);
  const [insurTypeNameInInputBoxNew, setInsurTypeNameInInputBoxNew] = useState(
    initialInsurTypeInAction,
  );
  const [insurTypeNameInInputBoxEdit, setInsurTypeNameInInputBoxEdit] =
    useState(initialInsurTypeInActionEdit);

  const editInsurTypeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/INSURTYPE/${insurTypeNameInInputBoxEdit.insurType_name}/${insurTypeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getInsurTypeList();
        setInsurTypeNameInInputBoxEdit(initialInsurTypeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteInsurTypeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/INSURTYPE/${insurTypeNameInInputBoxEdit.insurType_name}/${insurTypeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getInsurTypeList();
        setInsurTypeNameInInputBoxEdit(initialInsurTypeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const newInsurTypeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/INSURTYPE/${insurTypeNameInInputBoxNew.insurType_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getInsurTypeList();
        setInsurTypeNameInInputBoxNew(initialInsurTypeInAction);
      }, {})
      .catch((err) => {});
  };

  // useEffect(() => {
  //   console.log("formdata in insurance child 1. Initial :", formdata);
  // }, []);

  // useEffect(() => {
  //   console.log("formdata in insurance child   2. :", formdata);
  // }, [formdata]);

  return (
    <div>
      <h3 className="text-[#2663EB] font-semibold my-2">Insurance</h3>
      <div className=" p-4  rounded-lg grid grid-cols-3 gap-8">
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Started Date
          </label>

          <input
            type="date"
            placeholder="Enter Started Date..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.START_DATE || dayjs(formdata?.INSURANCE_START).format('YYYY-MM-DD') || ""}
            onChange={(e) => handleChange("START_DATE", e.target.value)}
          />
        </div>
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Expiry Date
          </label>

          <input
            type="date"
            placeholder="Enter Model..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.END_DATE || dayjs(formdata["INSURANCE EXPIRY"]).format('YYYY-MM-DD') || ""}
            
            onChange={(e) => handleChange("END_DATE", e.target.value)}
          />
        </div>
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Company
          </label>
          <div className="flex justify-between items-center gap-2">
            <select
              className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200 "
              onChange={(e) => handleChange("COMPANY", e.target.value)}
              value={formdata?.COMPANY || formdata?.INS_COMPANY || ""}
            >
              <option>--Select Company--</option>

              {companyListFromAPI?.map((item, index) => (
                <option value={item.Description} key={index}>
                  {item.Description}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={() => setShowCompanyCreationEditPopup(true)}
              className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md text-sm"
            >
              Manage
            </button>
          </div>
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Account No
          </label>

          <input
            placeholder="Enter Account No..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.ACC_NO || formdata?.ACCOUNTNO || ""}
            onChange={(e) => handleChange("ACC_NO", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Serial No
          </label>

          <input
            placeholder="Enter Serial No..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            onChange={(e) => handleChange("SERIAL_NO", e.target.value)}
            value={formdata?.SERIAL_NO || formdata?.SERIALNO || ""}
          />
        </div>
        <div className="">
          <div className="">
            <label className="block text-sm font-medium mb-1 flex items-center">
              Insurance Type
            </label>

            {/* <div className="flex justify-between items-center gap-2 w-full"> */}
            <div className="flex justify-between items-center gap-2 w-full">
              <select
                className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200 "
                onChange={(e) => handleChange("INSUR_TYPE", e.target.value)}
                value={formdata?.INSUR_TYPE  || formdata?.insuranceType || ""}
              >
                <option>--Select Type--</option>
                {insurTypeListFromAPI?.map((item, index) => (
                  <option value={item.Description} key={index}>
                    {item.Description}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={() => setShowInsurTypeCreationEditPopup(true)}
                className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md text-sm"
              >
                Manage
              </button>
            </div>
          </div>
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Premium
          </label>

          <input
            placeholder="Enter Premium..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            onChange={(e) => handleChange("PREMIUM", e.target.value)}
            value={formdata?.PREMIUM || ""}
          />
        </div>
      </div>

      {showCompanyCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                {/* <BusinessIcon className="text-[#2663EB]" /> */}
                COMPANY MANAGEMENT
              </h2>

              <button
                onClick={() => setShowCompanyCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Add New Company */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={companyNameInInputBoxNew.insurType_name}
                type="text"
                placeholder="Enter new company name here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                onChange={(e) =>
                  setCompanyNameInInputBoxNew((prev) => ({
                    ...prev,
                    insurType_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newCompanyAPI}
                className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
              >
                <Plus size={16} />
                Add Company
              </button>
            </div>

            {/* Company List */}
            <div className="mt-6 space-y-3">
              {companyListFromAPI?.map((item) => {
                const isEditing =
                  companyNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setCompanyNameInInputBoxEdit({
                            company_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-gray-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={companyNameInInputBoxEdit.insurType_name}
                          onChange={(e) =>
                            setCompanyNameInInputBoxEdit((prev) => ({
                              ...prev,
                              company_name: e.target.value,
                            }))
                          }
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setCompanyNameInInputBoxEdit(
                                initialCompanyInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editCompanyAPI}
                            className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {showInsurTypeCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                {/* <BusinessIcon className="text-[#2663EB]" /> */}
                INSURANCE TYPE MANAGEMENT
              </h2>

              <button
                onClick={() => setShowInsurTypeCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={insurTypeNameInInputBoxNew.insurType_name}
                type="text"
                placeholder="Enter new Insurance Type here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                onChange={(e) =>
                  setInsurTypeNameInInputBoxNew((prev) => ({
                    ...prev,
                    insurType_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newInsurTypeAPI}
                className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
              >
                <Plus size={16} />
                Add Insurance Type
              </button>
            </div>

            {/* Branch List */}
            <div className="mt-6 space-y-3">
              {insurTypeListFromAPI?.map((item) => {
                const isEditing =
                  insurTypeNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setInsurTypeNameInInputBoxEdit({
                            insurType_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-gray-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={insurTypeNameInInputBoxEdit.insurType_name}
                          onChange={(e) =>
                            setInsurTypeNameInInputBoxEdit((prev) => ({
                              ...prev,
                              insurType_name: e.target.value,
                            }))
                          }
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setInsurTypeNameInInputBoxEdit(
                                initialInsurTypeInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editInsurTypeAPI}
                            className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InsuranceDetails;
